import React from 'react';
import { Button, ButtonToolbar, OverlayTrigger, Popover, Glyphicon } from 'react-bootstrap';
import DayPicker from 'react-day-picker';
import { eventTypes } from './EventTypes';
import { connect } from 'react-redux';
import moment from 'moment';
import {
    updateDateFilter,
    updateUserFilter,
    updateLogTypeFilter,
    fetchLogs,
    removeUserFilter,
    removeLogTypeFilter,
    updatePageNumber,
} from '../../actions/reduxActions/logs';
import '../../../css/audit-logs.less';

import 'react-day-picker/lib/style.css';
import Select from 'react-select';
import { selectStyles } from '../../utils/core';

const datePickerRef = React.createRef();

export const getTypeOptions = () => Object.entries(eventTypes).map(([key, value]) => ({
    label: value.name,
    value: key,
}));

// The Metrics API returns this hardcoded Public user
export const PUBLIC_USER = {
    id: '52df1a90-3826-4508-b7c2-cde8aa5b72cf',
    email: null,
    firstName: 'Public',
    lastName: 'user',
};

/**
 * Users may not have first or last name set when logged in via SSO
 *
 * @param {Object} user
 */
export const humanizeAuditUser = (user) => {

    if (!user) {
        return 'NA';
    }

    if (user.id === PUBLIC_USER.id) {
        return `${user.firstName} ${user.lastName}`;
    }
    if (user.firstName && user.lastName) {
        return `${user.firstName} ${user.lastName} (${user.email})`;
    }
    if (user.lastName) {
        return `${user.lastName} (${user.email})`;
    }
    if (user.firstName) {
        return `${user.firstName} (${user.email})`;
    }
    // We always have an email because it's the login key, except Public users
    return user.email;
};

export const getUserOptions = users => users.map(user => ({
    label: humanizeAuditUser(user),
    value: user ? user.id : null,
}));

export const mapDispatchToProps = dispatch => ({
    getAuditLogs: (authenticationToken) => {
        dispatch(fetchLogs(authenticationToken));
    },
    updateDateFilter: (dateRange, authenticationToken) => {
        dispatch(updatePageNumber(1));
        dispatch(updateDateFilter(dateRange));
        dispatch(fetchLogs(authenticationToken));
    },
    updateUserFilter: (user, authenticationToken) => {
        dispatch(updatePageNumber(1));
        dispatch(updateUserFilter(user));
        dispatch(fetchLogs(authenticationToken));
    },
    updateLogTypeFilter: (logType, authenticationToken) => {
        dispatch(updatePageNumber(1));
        dispatch(updateLogTypeFilter(logType));
        dispatch(fetchLogs(authenticationToken));
    },
    removeUserFilter: (user, authenticationToken) => {
        dispatch(updatePageNumber(1));
        dispatch(removeUserFilter(user));
        dispatch(fetchLogs(authenticationToken));
    },
    removeLogTypeFilter: (logType, authenticationToken) => {
        dispatch(updatePageNumber(1));
        dispatch(removeLogTypeFilter(logType));
        dispatch(fetchLogs(authenticationToken));
    },
});

export const AuditLogsFilters = ({
    authenticationToken,
    users,
    logs,
    getAuditLogs,
    updateDateFilter,
    updateUserFilter,
    updateLogTypeFilter,
}) => {
    const typeOptions = getTypeOptions();
    const userOptions = getUserOptions(users);

    const chooseDatePopover = (
        <Popover id="popover-datepicker" className="audit-popover">
            <DayPicker
                selectedDays={logs.filterDate}
                onDayClick={
                    (date) => {
                        updateDateFilter(date, authenticationToken);
                        datePickerRef.current.click();
                    }
                }
            />
        </Popover>
    );

    return (
        <div className="audit-filters">
            <div className="date-filter filter-column" ref={datePickerRef}>
                <OverlayTrigger
                    container={datePickerRef.current}
                    trigger="click"
                    placement="bottom"
                    overlay={chooseDatePopover}
                    rootClose
                >
                    <input
                        className="form-control date-range-filter-input"
                        value={moment(logs.filterDate).format('MMM Do YYYY')}
                    />
                </OverlayTrigger>
            </div>

            <div className="type-filter filter-column">
                <Select
                    isMulti
                    styles={selectStyles}
                    options={typeOptions}
                    onChange={selectValue => updateLogTypeFilter(selectValue, authenticationToken)}
                    placeholder="All event types"
                    value={logs.filterTypes}
                    noOptionsMessage={() => 'No results found'}
                />
            </div>

            <div className="user-filter filter-column">
                <Select
                    isMulti
                    styles={selectStyles}
                    options={userOptions}
                    onChange={selectValue => updateUserFilter(selectValue, authenticationToken)}
                    placeholder="All users"
                    value={logs.filterUsers}
                    noOptionsMessage={() => 'No results found'}
                />
            </div>

            <div className="filter-column">
                <ButtonToolbar>
                    <Button
                        title="Refresh results"
                        className="btn-default"
                        onClick={() => getAuditLogs(authenticationToken)}
                    >
                        <Glyphicon glyph="refresh" />
                    </Button>
                </ButtonToolbar>
            </div>
        </div>
    );
};

export default connect(null, mapDispatchToProps)(AuditLogsFilters);
